import { ComponentTypes } from "../../Components/ComponentFactory/types";
import { commonFieldFormatter } from "../../formatters";
import { CommonSettings, SPLITTERS_TYPES, TRANSCEIVERS_TYPES, addditionalCalcParams, imagesList, partsTypes } from "../../settings";

const gainLossSettings = {
    type: ComponentTypes.STAT,
    valueID: "gain_loss",
    titleAlign: "center",
    measure: 'dB',
    contentAlign: 'flex-end',
    formatter: commonFieldFormatter
}

export const CalculatorSettings = {
    rows: [
        {
            name: "Transceiver",
            type: ComponentTypes.SELECT,
            values: Object.values(CommonSettings.hardware[partsTypes.TRANSCEIVERS]),
            defVal: TRANSCEIVERS_TYPES.COMBO_PON,
            id: "transceiver_1",
            imageSettings: imagesList.Transceiver,
            gainLossSettings: {
                ...gainLossSettings,
                id: "transceiver_1",
                bold: true,
                defVal: "Gain/Loss"
            }
        },
        {
            name: "XGS-PON TX",
            type: ComponentTypes.STAT,
            titleAlign: "right",
            defVal: '',
            id: "xgs_pon_tx_comb_trans",
            gainLossSettings: {
                ...gainLossSettings,
                id: "xgs_pon_tx_comb_trans",
                measure: 'dBm'
            }
        },
        {
            name: "GPON TX",
            type: ComponentTypes.STAT,
            titleAlign: "right",
            defVal: '',
            id: "gpon_tx_comb_trans",
            gainLossSettings: {
                ...gainLossSettings,
                id: "gpon_tx_comb_trans",
                measure: 'dBm'
            }
        },
        {
            name: "XGS-PON TX",
            type: ComponentTypes.STAT,
            titleAlign: "right",
            defVal: '',
            id: "xgs_pon_tx_xgs_trans",
            gainLossSettings: {
                ...gainLossSettings,
                id: "xgs_pon_tx_xgs_trans",
                measure: 'dBm'
            }
        },
        {
            name: "GPON TX",
            type: ComponentTypes.STAT,
            titleAlign: "right",
            defVal: '',
            id: "gpon_tx_gpon_trans",
            gainLossSettings: {
                ...gainLossSettings,
                id: "gpon_tx_gpon_trans",
                measure: 'dBm'
            }
        },
        {
            name: "Splitter 1",
            type: ComponentTypes.SELECT,
            defVal: SPLITTERS_TYPES.ONEx4,
            values:  Object.values(CommonSettings.hardware[partsTypes.SPLITTERS]),
            id: "splitter_1",
            imageSettings: imagesList.Splitter,
            gainLossSettings: {
                ...gainLossSettings,
                id: "splitter_1"
            }
        },
        {
            name: "Splitter 2",
            type: ComponentTypes.SELECT,
            defVal: SPLITTERS_TYPES.ONEx12,
            cleanable: true,
            values:  Object.values(CommonSettings.hardware[partsTypes.SPLITTERS]),
            id: "splitter_2",
            imageSettings: imagesList.Splitter,
            gainLossSettings: {
                ...gainLossSettings,
                id: "splitter_2"
            }
        },
        {
            name: "Splitter 3",
            type: ComponentTypes.SELECT,
            defVal: null,
            cleanable: true,
            values:  Object.values(CommonSettings.hardware[partsTypes.SPLITTERS]),
            id: "splitter_3",
            imageSettings: imagesList.Splitter,
            gainLossSettings: {
                ...gainLossSettings,
                id: "splitter_3"
            }
        },
        {
            name: "Splice Quantity",
            type: ComponentTypes.INPUT,
            defVal: CommonSettings.additional_calc_params[addditionalCalcParams.SPLICE_QTY].defVal,
            id: "splice_qty",
            imageSettings: imagesList.SpliceQTY,
            gainLossSettings: {
                ...gainLossSettings,
                id: "splice_qty"
            }
        },
        {
            name: "Aging margin",
            type: ComponentTypes.INPUT,
            defVal: CommonSettings.additional_calc_params[addditionalCalcParams.AGING_MARGIN].defVal,
            measure: 'dB',
            id: "aging_margin",
            imageSettings: imagesList.Aging,
            gainLossSettings: {
                ...gainLossSettings,
                id: "aging_margin"
            }
        },
        {
            name: "Connectors",
            type: ComponentTypes.INPUT,
            defVal: CommonSettings.additional_calc_params[addditionalCalcParams.CONNECTORS].defVal,
            id: "connectors",
            imageSettings: imagesList.Connectors,
            gainLossSettings: {
                ...gainLossSettings,
                id: "connectors"
            }
        },
        {
            name: "Measurement Error",
            type: ComponentTypes.STAT,
            id: "measurement_error",
            imageSettings: imagesList.Measure,
            gainLossSettings: {
                ...gainLossSettings,
                id: "measurement_error"
            }
        },
        {
            name: "Total Distance",
            type: ComponentTypes.INPUT,
            defVal: CommonSettings.additional_calc_params[addditionalCalcParams.TOTAL_DISTANCE].defVal,
            id: "total_distance",
            imageSettings: imagesList.Distance,
            gainLossSettings: {
                ...gainLossSettings,
                id: "total_distance"
            },
            additionalSettings: {
                type: ComponentTypes.SELECT,
                defVal: CommonSettings.additional_calc_params[addditionalCalcParams.TOTAL_DISTANCE_MEASURE].defVal,
                cleanable: false,
                values:  Object.values(CommonSettings.distance_measures),
                id: "total_distance_measure"
            }
        },
        {
            name: "Margin Requirement",
            type: ComponentTypes.INPUT,
            defVal: CommonSettings.additional_calc_params[addditionalCalcParams.MARGIN_REQUIREMENT].defVal,
            measure: 'dB',
            id: "margin_requirement",
            imageSettings: imagesList.MarginReq,
            gainLossSettings: {
                ...gainLossSettings,
                id: "margin_requirement"
            }
        },
    ]
}


